<div class="common-report-result d-flex justify-content-around">
  <div *ngIf="+generalReportInfo.feedbackCollectionPeriod>=0">
    <div class="title line-break">{{ 'lang.reporting.feedbackPeriod' | translate }}</div>
    <span>{{ generalReportInfo.feedbackCollectionPeriod }}</span>
    <span class="description">{{ 'lang.reporting.days' | translate }}</span>
  </div>
  <div *ngIf="+generalReportInfo.responseRate>=0">
    <div class="title line-break">{{ 'lang.reporting.responceRate' | translate }}</div>
    <span>{{ generalReportInfo.responseRate }}</span>
    <span class="description">%</span>
  </div>
  <div *ngIf="+generalReportInfo.totalResponses>=0">
    <div class="title line-break">{{ 'lang.reporting.totalResponses' | translate }}</div>
    <span>{{ generalReportInfo.totalResponses }}</span>
  </div>
</div>